exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".btn-view[data-v-4bb21427]{padding:3px 7px;border:none;border-radius:3px;margin-left:3px}.btn-view svg[data-v-4bb21427]{width:13px;height:13px}", "", {"version":3,"sources":["/app/src/components/master/tag/Tag.vue"],"names":[],"mappings":"AACA,2BACE,gBAAiB,AACjB,YAAa,AACb,kBAAmB,AACnB,eAAiB,CAClB,AACD,+BACE,WAAY,AACZ,WAAa,CACd","file":"Tag.vue","sourcesContent":["\n.btn-view[data-v-4bb21427] {\n  padding: 3px 7px;\n  border: none;\n  border-radius: 3px;\n  margin-left: 3px;\n}\n.btn-view svg[data-v-4bb21427] {\n  width: 13px;\n  height: 13px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4bb21427","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/master/tag/Tag.vue
// module id = 1066
// module chunks = 40